import { useSharedDraftRecord } from "@/hooks/useSharedDraftRecord";
import {
  CLAIM_RECEIPTS_FORM_TYPE,
  claimReceiptsDraftId,
  emptyClaimReceipts,
  normaliseClaimReceipts,
} from "@/lib/claimReceipts";

// The firm's Claim receipts folder, shared by the Fee Slips & Invoices and Disbursements
// pages (src/lib/claimReceipts.js).
export function useClaimReceipts(brand, prefix = "") {
  return useSharedDraftRecord({
    brand,
    formType: CLAIM_RECEIPTS_FORM_TYPE,
    draftId: claimReceiptsDraftId(brand),
    draftName: `${prefix ? `${prefix} ` : ""}Claim receipts`,
    empty: emptyClaimReceipts,
    normalise: normaliseClaimReceipts,
    label: "Claim receipts",
  });
}
